import React from "react";

import { useBeam } from "@randajan/bifrost/client/react";

import { Counter } from "@randajan/jet-react/dom/counter";
import { Block } from "@randajan/jet-react/dom/block";
import { Caption } from "@randajan/jet-react/dom/caption";

import "./Numbers.scss";
import { globalStatsBeam } from "../../../assets/beams/globalStatsBeam";
import { useInView } from "react-intersection-observer";

import { Locale } from "../../../assets/Locale";
import { ImgStore } from "../../../elements/ImgStore/ImgStore";


export const NumberTile = (props)=>{
    const { img, caption, number } = props;
    const [ref, inView] = useInView({ triggerOnce:true, threshold:.8 });

    return (
        <div ref={ref} className="NumberTile">
            <ImgStore src={img}/>
            <Counter duration={Number.jet.rnd(2000, 3000)}>{inView ? number : 0}</Counter>
            <Caption>{caption}</Caption>
        </div>
    );
};

export const Numbers = (props)=>{
    const {} = props;
    const say = Locale.use();

    const { data:globalStats } = useBeam(globalStatsBeam);
    const { rounds, users } = (globalStats || {});

    return (
        <Block className="Numbers grid">
            <NumberTile number={users?.stats.total.count} img="iconStrapUser.webp" caption={say("landingNumbersPlayers")}/>
            <NumberTile number={rounds?.stats.count} img="logoStrapCircle.webp" caption={say("landingNumbersGames")}/>
            <NumberTile number={Math.round(rounds?.stats.totalMs / 1000 / 60 / 60)} img="iconStrapClock.webp" caption={say("landingNumbersHours")}/>
            <NumberTile number={rounds?.stats.betaWon} img="iconStrapBomb.webp" caption={say("landingNumbersSabotages")}/>
        </Block>
    );
};
